export enum PaymentMethodType {
    Card = 0,
    BankAccount = 1,
    PayPal = 2,
    BitPay = 3,
    Credit = 4,
    WireTransfer = 5,
}
